"use client";

import React from "react";
import Image from "next/image";
import styles from "./agent-contact-card.module.css";
import {
  PrivateUserCreator,
  AgentCreator,
  AgencyCreator,
  UserTypes,
} from "@/types/types";
import {
  IoCallOutline,
  IoChatbubblesOutline,
  IoCalendarOutline,
  IoStar,
} from "react-icons/io5";

type Creator = PrivateUserCreator | AgentCreator | AgencyCreator;

interface AgentContactCardProps {
  creator: Creator;
  isPremium?: boolean;
}

export default function AgentContactCard({
  creator,
  isPremium = false,
}: AgentContactCardProps) {
  // Determine subtitle based on user type
  let subtitle = "Proprietar";
  if (creator.type === UserTypes.AGENT) {
    subtitle = isPremium ? "Agent imobiliar premium" : "Agent imobiliar";
  } else if (creator.type === UserTypes.AGENCY) {
    subtitle = "Agenție imobiliară";
  }

  // Mocking the rating since it wasn't explicitly in the provided types,
  // but it is prominent in the design. You can swap this with real data later.
  const mockRating = 4.9;
  const mockReviews = 128;

  return (
    <div className={styles.card}>
      <h3 className={`${styles.title} ${isPremium ? styles.titlePremium : ""}`}>
        Contactează {creator.type === UserTypes.AGENCY ? "agenția" : "agentul"}
      </h3>

      <div className={styles.profileRow}>
        <div className={styles.avatarWrapper}>
          <Image
            src={creator.photo_url || "/placeholder-avatar.jpg"}
            alt={creator.name}
            fill
            sizes="80px"
            className={styles.avatar}
          />
        </div>

        <div className={styles.infoCol}>
          <span className={styles.name}>{creator.name}</span>
          <span className={styles.subtitle}>{subtitle}</span>

          {/* Rating Row */}
          <div className={styles.ratingRow}>
            <IoStar className={styles.starIcon} />
            <span className={styles.ratingValue}>{mockRating}</span>
            <span className={styles.reviewCount}>({mockReviews} recenzii)</span>
          </div>
        </div>
      </div>

      <div className={styles.actionsGroup}>
        <button className={`${styles.btn} ${styles.btnPrimary}`}>
          <IoCallOutline className={styles.btnIcon} />
          <span>Sună acum</span>
        </button>

        <button className={`${styles.btn} ${styles.btnSecondary}`}>
          <IoChatbubblesOutline className={styles.btnIcon} />
          <span>Trimite mesaj</span>
        </button>

        <button className={`${styles.btn} ${styles.btnSecondary}`}>
          <IoCalendarOutline className={styles.btnIcon} />
          <span>Programează vizionare</span>
        </button>
      </div>
    </div>
  );
}
